import gz_custom_module_fn from './gz_custom_module';
import gz_custom_decompress from './gz_custom_decompress';

export class GzCustomDecompressor {
    static async decompress(gzipBuffer) {
        return new Promise(async (resolve, reject) => {
            const runtimeParams = {
                noExitRuntime: true
            };
            const gz_custom_module = await gz_custom_module_fn(runtimeParams);

            const handleBuffer = () => {
                console.log('handleBuffer called', gz_custom_module);
                const decompressedString = gz_custom_decompress.gz_custom_decompress(gz_custom_module, gzipBuffer);
                console.log('gz_custom_decompress finished: length=', decompressedString.length);

                if (decompressedString) {
                    resolve(decompressedString);
                } else {
                    reject();
                }
            };

            await gz_custom_module.ready;
            handleBuffer();
        });
    }
}
